import { ArrowLeft, Heart, Star, Users, Utensils } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useLocation } from "wouter";

export default function About() {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-background/95 backdrop-blur-sm border-b">
        <div className="flex items-center gap-3 px-4 py-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setLocation("/")}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-lg font-semibold">About Eatzy</h1>
        </div>
      </header>

      <main className="p-4 pb-8 max-w-2xl mx-auto space-y-6">
        <div className="flex flex-col items-center text-center py-6">
          <img src="/eatzy-kudoz-logo.png" alt="Eatzy Kudoz" className="w-20 h-20 mb-4" />
          <h2 className="text-2xl font-bold">Eatzy Kudoz</h2>
          <p className="text-muted-foreground mt-1">Discover. Review. Earn Rewards.</p>
        </div>

        <Card>
          <CardContent className="p-5 space-y-4">
            <p className="text-sm leading-relaxed">
              Eatzy Kudoz is a social restaurant discovery platform that makes finding
              great food fun and rewarding. Share your dining experiences through photos
              and reviews, discover new restaurants, and earn Kudoz rewards for every
              contribution.
            </p>
          </CardContent>
        </Card>

        <div className="grid grid-cols-2 gap-3">
          <Card>
            <CardContent className="p-4 text-center">
              <Utensils className="w-8 h-8 mx-auto mb-2 text-primary" />
              <h3 className="font-medium text-sm">Discover</h3>
              <p className="text-xs text-muted-foreground mt-1">
                Find restaurants near you with real reviews from real diners
              </p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-4 text-center">
              <Star className="w-8 h-8 mx-auto mb-2 text-primary" />
              <h3 className="font-medium text-sm">Review</h3>
              <p className="text-xs text-muted-foreground mt-1">
                Share your dining experiences with photos and honest ratings
              </p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-4 text-center">
              <Heart className="w-8 h-8 mx-auto mb-2 text-primary" />
              <h3 className="font-medium text-sm">Earn</h3>
              <p className="text-xs text-muted-foreground mt-1">
                Get Kudoz rewards for reviews, orders, and engagement
              </p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-4 text-center">
              <Users className="w-8 h-8 mx-auto mb-2 text-primary" />
              <h3 className="font-medium text-sm">Connect</h3>
              <p className="text-xs text-muted-foreground mt-1">
                Follow friends and discover what they love to eat
              </p>
            </CardContent>
          </Card>
        </div>

        <Separator />

        <div className="text-center space-y-2">
          <p className="text-xs text-muted-foreground">
            Version 1.0.0
          </p>
          <div className="flex items-center justify-center gap-4 text-xs text-muted-foreground">
            <button onClick={() => setLocation("/privacy")} className="hover:underline">
              Privacy Policy
            </button>
            <button onClick={() => setLocation("/terms")} className="hover:underline">
              Terms of Service
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
